import styled from 'styled-components';
import theme from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const UploadAreaWrapper = styled.div`
  position: relative;
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const UploadArea = styled.label<{ hasImage: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  border: 2px dashed ${theme.colors.primary.bg.regular};
  border-radius: 8px;
  cursor: ${({ hasImage }) => (hasImage ? 'default' : 'pointer')};
  transition: all 0.2s ease-in-out;
  background-color: ${theme.colors.neutral.bg.inverted};
  min-height: 120px;

  &:hover {
    ${({ hasImage }) =>
      !hasImage &&
      `
      border-color: ${theme.colors.primary.bg.strong};
      background-color: ${theme.colors.primary.bg.inverted};
    `}
  }

  input[type='file'] {
    display: none;
  }
`;

export const UploadContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ImagePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 200px;
  
  img {
    max-width: 100%;
    max-height: 200px;
    object-fit: contain;
  }
`;

export const InfoText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const ErrorText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
